import { render, staticRenderFns } from "./WishListCount.vue?vue&type=template&id=4a95fc63&"
import script from "./WishListCount.vue?vue&type=script&lang=js&"
export * from "./WishListCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thayamohanmohanathas/Documents/GitHub/Phywe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a95fc63')) {
      api.createRecord('4a95fc63', component.options)
    } else {
      api.reload('4a95fc63', component.options)
    }
    module.hot.accept("./WishListCount.vue?vue&type=template&id=4a95fc63&", function () {
      api.rerender('4a95fc63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/phywe/WishListCount.vue"
export default component.exports